import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import AssessmentIcon from '@mui/icons-material/Assessment';
import GroupIcon from '@mui/icons-material/Group';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import type { OrgSummaryResponse } from '../../../api/generated';
import { MetricCard } from './MetricCard';
import { ScoreDistribution } from './ScoreDistribution';

interface OrgSummaryCardsProps {
  summary: OrgSummaryResponse;
}

export function OrgSummaryCards({ summary }: OrgSummaryCardsProps) {
  return (
    <Box>
      {/* Summary Metric Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid size={{ xs: 12, sm: 4 }}>
          <MetricCard
            title="Total Scored Calls"
            value={summary.total_calls}
            icon={<AssessmentIcon />}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <MetricCard
            title="Avg Overall Score"
            value={summary.avg_overall_score}
            icon={<TrendingUpIcon />}
            format="score"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <MetricCard title="Total Reps" value={summary.total_reps} icon={<GroupIcon />} />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        {/* Top Performers */}
        {summary.top_performers.length > 0 && (
          <Grid size={{ xs: 12, md: 6 }}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Top Performers
              </Typography>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell align="right">Avg Score</TableCell>
                      <TableCell align="right">Calls</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {summary.top_performers.map((performer, idx) => (
                      <TableRow key={performer.user_id}>
                        <TableCell>{idx + 1}</TableCell>
                        <TableCell>{performer.display_name || performer.user_id}</TableCell>
                        <TableCell align="right">
                          <Typography sx={{
                            fontWeight: 600
                          }}>{performer.avg_score}</Typography>
                        </TableCell>
                        <TableCell align="right">{performer.call_count}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        )}

        {/* Score Distribution */}
        {Object.keys(summary.score_distribution).length > 0 && (
          <Grid size={{ xs: 12, md: 6 }}>
            <Paper sx={{ p: 3, height: '100%' }}>
              <Typography variant="h6" gutterBottom>
                Score Distribution
              </Typography>
              <ScoreDistribution data={summary.score_distribution} />
            </Paper>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
